<script setup>
import { computed } from 'vue';
import { PhxProductSlider } from '@phx-styleguides/iwc';
import { set } from 'lodash-es';
import { usePrice } from '@phoenix/composables/price';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  slides: {
    type: Array,
    required: true,
  },
});

const { localizedPrice, localizedPriceDisplayValue } = usePrice();

const computedSlides = computed(() =>
  props.slides.map((slide) => {
    const newSlide = structuredClone(slide);

    set(
      newSlide,
      ['data', 'content', 'price'],
      localizedPriceDisplayValue(
        localizedPrice(newSlide.data.content.price.price),
        newSlide.data.content.price.shouldDisplayFromPrice,
      ),
    );

    return newSlide;
  }),
);
</script>

<template>
  <phx-product-slider :id="id" :label="label" :slides="computedSlides" />
</template>
